export const LOGO_URL =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_6303c277-f811-4715-9c8e-4662bbf17b5b/artifacts/eezc16j0_file_00000000b67481f48c71cb5187d9f6ad.png";

export default function Logo({ size = "md" }) {
  const dims = { sm: { box: 28, text: "text-lg" }, md: { box: 36, text: "text-2xl" }, lg: { box: 56, text: "text-4xl" }, xl: { box: 76, text: "text-5xl" } }[size] || { box: 36, text: "text-2xl" };
  return (
    <div className="flex items-center gap-2.5 select-none" data-testid="brand-logo">
      <span className="relative inline-block rounded-full brand-grad shadow-lg shadow-brand/30" style={{ width: dims.box, height: dims.box }}>
        <span className="absolute bg-white rounded-full" style={{ width: dims.box * 0.16, height: dims.box * 0.42, left: dims.box * 0.3, top: dims.box * 0.26, transform: "rotate(18deg)" }} />
        <span className="absolute bg-white rounded-full" style={{ width: dims.box * 0.16, height: dims.box * 0.42, left: dims.box * 0.54, top: dims.box * 0.32, transform: "rotate(18deg)" }} />
      </span>
      <span className={`font-head font-extrabold tracking-tight ${dims.text}`}>
        <span className="text-brand-500">smsonay</span>
        <span className="text-panel-secondary">.site</span>
      </span>
    </div>
  );
}
